import React from 'react';
import { useLocalization } from '../../../localization'; // Added import
import SEO from '../../../components/SEO';
import SyncSelectList from '../components/SyncSelectList';

const SyncListPage = () => {
  const { t } = useLocalization(); // Added hook call
  return (
  <div className="cb-content-frame h-full">
    <SEO title={t('sync.dashboard_title')} /> {/* Localized */}
    <div  className="cb-content-pane mobile_padding min-h-screen" >
    
  
    <SyncSelectList />
    </div>
  </div>
)}; // Added missing closing brace

export default SyncListPage
